/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({

	card: {
		':active:focus': {
			boxShadow: 'none',
			outline: 'none'
		},
		':focus': {
			boxShadow: 'none',
			outline: 'none'
		}
	},
	title: {
		fontSize: '1rem',
		marginBottom: 0,
		padding: '.625rem 0'
	}
});

export default styles;
